import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const store = new Vuex.Store({
  mutations: {},
  actions: {},
  modules: {
    // auth: AuthModule
  }
});
export default store;
